import { Download } from "lucide-react";

const BASE = "https://static.prod-images.emergentagent.com/jobs/7e09a981-f25d-4bee-a6b0-8e6f5a9cddd0/images/";
const ICONS = [
  ["Logo: Aura + PN28", "6ea3ec021e2ecb2b020ef31f2c89cecb3059e658ab43b9a643747109f36031d8"],
  ["Logo: Aura Icon", "08497c10c44422c6f221ec5ecaf224fcf2ef87478108d6ab3de6285c5ed2362e"],
  ["Logo: Minimal", "1213755bb18360754fe1154cbcbd5441c106bf1844d44cfb68cd8bf88d0f3ccd"],
  ["Profilbild", "2442059cd396e1cd44b7e59ccc9eccd99b67d85e780b666c932f9552260bf6a1"],
  ["Highlight: Neu", "9848a725c0dae743b265e02c3576e1127e1e0a0cd1f3e6f431f87211a078b331"],
  ["Highlight: Shop", "a626b76b1bce2fd62550e3dbf17867bde34a7356cb3ec295400bc2ef2c3d3caa"],
  ["Highlight: Pulls", "f4c57e99187a4c0598b146b1817d0abaf0ccc441909dce780fbf7cd559f8244f"],
  ["Highlight: Versand", "16efa18cbbd9e7d5212d8458cb3ef8e725c2faf368f918a975e5b7650b6a0d4e"],
  ["Highlight: Reviews", "2363aadd5397ab94735632efb3f21f7a884c2944231692fd90843396794ac85e"],
];

export const InstagramPanel = () => (
  <div className="space-y-4">
    <p className="text-sm text-[#707783]">Instagram-Assets für @pn28cards – Profilbild und Story-Highlight-Cover.</p>
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
      {ICONS.map(([label, id]) => (
        <a key={id} href={`${BASE}${id}.jpeg`} target="_blank" rel="noreferrer" download data-testid={`ig-asset-${label}`}
          className="group bg-white rounded-2xl border border-[#120E1F]/5 p-4 text-center hover:border-[#F2C230] transition-colors">
          <img src={`${BASE}${id}.jpeg`} alt={label} className="w-full aspect-square rounded-full object-cover" />
          <p className="text-xs mt-3 flex items-center justify-center gap-1">{label}<Download className="h-3 w-3 opacity-0 group-hover:opacity-100 transition-opacity" /></p>
        </a>
      ))}
    </div>
  </div>
);
